import {
    FETCH_IBEACONS,
} from '../actions/ibeanconConfig';


export const initialState = {
    isFetching: true,
    data: null
};

export const ibeacons = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_IBEACONS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_IBEACONS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

/*
export const ibeacon = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_IBEACON}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_IBEACON}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
*/



// WEBPACK FOOTER //
// ./src/redux/reducers/ibeaconConfig.js